import IActionsResolver from 'globx/dist/Store/Interfaces/IActionsResolver';
import * as xss         from 'xss';

import Frame from '../Frame/Frame';

import Captions         from './Captions';
import Cue              from './Cue';
import ICaptionsActions from './Interfaces/ICaptionsActions';
import ICue             from './Interfaces/ICue';
import Track            from './Track';

const resolveCaptionsActions: IActionsResolver<Captions, ICaptionsActions> = (
    value: Captions
): ICaptionsActions => ({
    loadTracks(tracks: Track[]): void {
        value.tracks = tracks;
    },

    setActiveTrack(language: string): void {
        value.tracks = value.tracks.map(track => {
            if (language === track.language) {
                track.isActive = true;
            } else {
                track.isActive = false;
            }

            return track;
        });
    },

    showCues(cues: ICue[]): void {
        // NB: Cue text is sanitized in order to prevent XSS attacks.
        // Because cue text can contain HTML, it is rendered using React's
        // `dangerouslySetInnerHTML` API, which makes it a potential attack
        // vector.

        value.activeCues = cues.map(cue => Object.assign(new Cue(), {
            text: xss(cue.text, {
                whiteList: {
                    i: [],
                    b: [],
                    u: []
                }
            })
        }));
    },

    hideCues(): void {
        value.activeCues = [];
    },

    deriveFrame(frame: Frame): void {
        value.frame = frame;
    }
});

export default resolveCaptionsActions;